










































import { UmbrellaType } from "@/models/products/umbrella";
import { Component } from "vue-property-decorator";
import Collections from "./Collections";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
import { getImg } from "@/utility/helpers";
@Component({
  components: {
    AccordionSection
  }
})
export default class UmbrellaMenu extends Collections {
  protected getImg = getImg;
  protected umbrellaType = UmbrellaType;
}
